import Model, { ID, Integer, IsoDateTime } from 'src/models/model'

export default class MarketingSubscription extends Model {
  static name = 'MarketingSubscription'

  static isConfiguration = true

  static versioned = true

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Marketing]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      siteId: {
        type: ID,
        required: true,
        output: true
      },
      siteName: {
        type: String,
        required: true,
        output: true
      },
      displayOrder: {
        type: Integer,
        default: 9999,
        required: true
      },
      channelEmail: {
        type: Boolean,
        default: true
      },
      channelPush: {
        type: Boolean,
        default: false
      },
      channelSms: {
        type: Boolean,
        default: false
      },
      excludeFromRegistration: {
        type: Boolean,
        default: false
      },
      archivedAt: {
        type: IsoDateTime,
        output: true
      },
      action: {
        type: String,
        default: null,
        input: true
      }
    }
  }

  hasChannelEnabled (channel) {
    switch (channel) {
      case 'email':
        return this.channelEmail
      case 'push':
        return this.channelPush
      case 'sms':
        return this.channelSms
      default:
        return false
    }
  }
}
